import React from "react";
import axios from "axios";
function SignUpForm() {
    const [state, setState] = React.useState({
        name: "",
        email: "",
        password: ""
    });
    const handleChange = evt => {
        const value = evt.target.value;

        setState({
            ...state,
            [evt.target.name]: value
        });
    };

    const handleOnSubmit = async (evt) => {
        evt.preventDefault();

        const { email, password } = state;
        try {
            const csrfToken = document.querySelector("meta[name='csrf-token']").getAttribute("content");
            const response = await axios.post(
                '/signup',
                {
                    user: {
                        email: email,
                        password: password
                    }
                },
                {
                    headers: {
                        'X-CSRF-Token': csrfToken
                    }
                }
            );
            alert('Inscription réussie!');
            console.log(response.data);
        } catch (error) {
            alert('Erreur inscription!');
            console.error(error);
        }
        for (const key in state) {
            setState({
                ...state,
                [key]: ""
            });
        }
    };

    return (
        <div className="form-container sign-up-container">
            <form className="auth-form" onSubmit={handleOnSubmit}>
                <h1 className="auth-title">Créer ton compte</h1>

                <input
                    type="email"
                    name="email"
                    value={state.email}
                    onChange={handleChange}
                    className="auth-input"
                    placeholder="Email"
                />
                <input
                    type="password"
                    name="password"
                    value={state.password}
                    onChange={handleChange}
                    className="auth-input"
                    placeholder="Password"
                />
                <button type="submit" className="auth-button">S'enregistrer</button>
            </form>
        </div>
    );
}

export default SignUpForm;
